import { BlStatusEnum, ContainerStatusEnum, DocStatusEnum, FgStatusEnum, GlobalStatus, InvoiceStatusEnum, JobTypesEnum, PmStatusEnum, QualityCheckStatusEnum, RmStatusEnum, SaleOrderStatusEnum, SoProcessTypesEnum, SoStatusEnum, SoTypesEnum } from "@gtpl/shared-models/common-models";
import { CustomerDto, CustomersResponseModel, EndCustomerDto, EndCustomerResponseModel, FoodTypesDto, SkuDataRequest } from "@gtpl/shared-models/masters";
import { BomDetails } from "../bom-calculation.entity";
import { BomDetailsLog } from "../bom-details-log.entity";

import { SoInvoiceDetails } from "../sale-invoice-details.entity";
import { SaleOrderItems } from "../sale-order-items.entity";
import { SaleOrder } from "../sale-order.entitiy";
import { SaleInspectionDetails } from "../so-inspections.entity";
import { SaleOrderItemsLog } from "../so-items-log.entity";
import { SaleOrderLog } from "../so-log.entity";
import { SaleOrderTrack } from "../so-track.entity";
import { SalePoDetails } from "../so_po_details.entity";
import { SaleOrderItemsInfo } from "./sale-order-items-info.model";
import { SaleOrderDto } from "./sale-order.dto";

export class SaleOrderAdapter {

    convertDtoToEntity(dtoObj: SaleOrderDto, isUpdate: boolean, soNumber, soQtyMap,samePonetWeightMap,operation,totSoItemsCount:number): SaleOrder {
        try {

            const entityObj = new SaleOrder();
            // entityObj.saleOrderId = dtoObj.saleOrderId;
            entityObj.createdUser = dtoObj.createdUser;
            entityObj.soProcessType = dtoObj.soProcessType;
            entityObj.soType = dtoObj.soType;
            // entityObj.createdUser = dtoObj.createdUser;
            // entityObj.saleOrderNumber = dtoObj.saleOrderNumber;
            if(!isUpdate || (isUpdate && dtoObj.soInvDetailsInfo.jobType == JobTypesEnum.SUB_JOB)){

                entityObj.saleOrderNumber = soNumber;
            }

            entityObj.status = dtoObj.status;
            const saleOrderItmes: SaleOrderItems[] = [];
            let soInspections:SaleInspectionDetails[] = [];
            let refNumber = totSoItemsCount;
            // let soItembarcode = SoItemRefNumber;
            let SoItemRefrNumber = totSoItemsCount + "";
            while (SoItemRefrNumber.length < 6) SoItemRefrNumber = "0" + SoItemRefrNumber;

            for (const soItem of dtoObj.saleOrderItemsInfo) {
                const soItemsObject: SaleOrderItems = new SaleOrderItems();
                // const finPercentage = percentageMap.get(soItem.varientId).get(soItem.soakingStyle)
                if(soItem.saleOrderItemId && operation != 'SUB JOB CREATE' && operation != 'CLONE'){
                soItemsObject.saleOrderItemId = soItem.saleOrderItemId;
                soItemsObject.saleOrderInfo = new SaleOrder();
                soItemsObject.saleOrderInfo.saleOrderId = dtoObj.saleOrderId;
                soItemsObject.updatedUser = soItem.updatedUser;
                // console.log(soItemsObject);
            }
                soItemsObject.cases = soItem.cases; 
                if(operation == 'SUB JOB EDIT'){
                    
                }
                soItemsObject.netWeight = soItem.netWeight;  
                if(operation == 'SUB JOB CREATE'){
                    soItemsObject.mainSoItemId = soItem.saleOrderItemId;    
                }
                if(soItem.saleOrderItemId && dtoObj.soInvDetailsInfo.jobType == JobTypesEnum.SUB_JOB && operation == 'SUB JOB CREATE'){
                    soItemsObject.cases = soQtyMap.get(soItem.saleOrderItemId)
                    soItemsObject.netWeight = samePonetWeightMap.get(soItem.saleOrderItemId)
                    soItemsObject.refNumber = refNumber
                    soItemsObject.barcode = SoItemRefrNumber
                }
                if((soItem.saleOrderItemId && dtoObj.soInvDetailsInfo.jobType == JobTypesEnum.SUB_JOB && operation == 'SUB JOB CREATE') || (soItem.saleOrderItemId && operation == 'CLONE')){
                    soItem.saleOrderItemId = undefined
                }
                if((!isUpdate && operation == 'CREATE')){
                    console.log('resttt2')

                    soItemsObject.refNumber = refNumber
                    soItemsObject.barcode = SoItemRefrNumber
                }
                console.log(operation,'operationnnn')
                if((isUpdate && !(soItem?.saleOrderItemId))){
                    console.log('resttt2')

                    soItemsObject.refNumber = refNumber
                    soItemsObject.barcode = SoItemRefrNumber
                }

                soItemsObject.itemId = soItem.itemId;
                soItemsObject.finalPercentage = soItem.finalPercentage;
                soItemsObject.minGrade = soItem.minGrade;
                soItemsObject.maxGrade = soItem.maxGrade;
                soItemsObject.foodTypeId = soItem.foodTypeId;
                soItemsObject.valueAdditionOneId = soItem.valueAdditionOneId;
                soItemsObject.valueAdditionTwoId = soItem.valueAdditionTwoId;
                soItemsObject.valueAdditionThreeId = soItem.valueAdditionThreeId;
                soItemsObject.valueAdditionFourId = soItem.valueAdditionFourId;
                soItemsObject.valueAdditionFiveId = soItem.valueAdditionFiveId;
                soItemsObject.varientId = soItem.varientId;
                soItemsObject.pouches = soItem.pouches;
                soItemsObject.palletCapacity = soItem.palletCapacity;
                
                soItemsObject.jobCases = soItem.cases;
                soItemsObject.caseWeight = soItem.caseWeight;
                soItemsObject.netAmount = soItem.netAmount;
                soItemsObject.createdUser = soItem.createdUser;
                soItemsObject.pouchWeight = soItem.pouchWeight;
                soItemsObject.categoryId = soItem.categoryId;
                soItemsObject.unitPrice = soItem.unitPrice;
                soItemsObject.brandId = soItem.brandId;
                soItemsObject.masterBrandId = soItem.masterBrandId;
                soItemsObject.uomId = soItem.uomId;
                soItemsObject.packStyleId = soItem.packStyleId;
                soItemsObject.innerBags = soItem.innerBags;
                soItemsObject.shrimpWeight = soItem.shrimpWeight;
                soItemsObject.skewerSizeItemId = soItem.skewerSizeItemId;
                soItemsObject.innerBagSizeId = soItem.skewerSizeItemId;
                // soItemsObject.freezeStle = soItem.freezeStle;
                soItemsObject.minGlaze = soItem.minGlaze;
                soItemsObject.MaxGlaze = soItem.MaxGlaze;
                soItemsObject.soakingTime = soItem.soakingTime;
                soItemsObject.soakingStyle = soItem.soakingStyle;
                soItemsObject.styleWeighment = soItem.styleWeighment;
                soItemsObject.category = soItem.category;
                soItemsObject.requiredCount = soItem.requiredCount;
                soItemsObject.createdUser = soItem.createdUser;
                saleOrderItmes.push(soItemsObject);
                refNumber = refNumber+1;
                // let soItembarcode = SoItemRefNumber;
                SoItemRefrNumber = refNumber + "";
                while (SoItemRefrNumber.length < 6) SoItemRefrNumber = "0" + SoItemRefrNumber;

            }

            // const bomDetails : BomDetails[] = [];


            
            const soInvObject: SoInvoiceDetails = new SoInvoiceDetails();
            if(dtoObj.soInvDetailsInfo.invDetailsId && operation != 'SUB JOB CREATE' && operation != 'CLONE'){
                soInvObject.invDetailsId = dtoObj.soInvDetailsInfo.invDetailsId;
                soInvObject.saleOrderInfo = new SaleOrder();
                soInvObject.saleOrderInfo.saleOrderId = dtoObj.saleOrderId;

            }

            if((dtoObj.soInvDetailsInfo.invDetailsId && dtoObj.soInvDetailsInfo.jobType == JobTypesEnum.SUB_JOB && operation == 'SUB JOB CREATE') || (dtoObj.soInvDetailsInfo.invDetailsId && operation == 'CLONE')){
                dtoObj.soInvDetailsInfo.invDetailsId = undefined
            }

            soInvObject.poNumber = dtoObj.soInvDetailsInfo.poNumber;
            soInvObject.buyerPoNumber = dtoObj.soInvDetailsInfo.buyerPoNumber;
            soInvObject.invoiceDate = dtoObj.soInvDetailsInfo.invoiceDate;
            soInvObject.edaDate = dtoObj.soInvDetailsInfo.edaDate;
            if(!isUpdate){
                soInvObject.edlDate = dtoObj.soInvDetailsInfo.edlDate;
            }
            if(isUpdate && dtoObj.soType == SoTypesEnum.STOCK){
                soInvObject.edlDate = dtoObj.soInvDetailsInfo.edlDate;
            }

            soInvObject.actualEdldate = dtoObj.soInvDetailsInfo.edlDate;
            soInvObject.cusAddress = dtoObj.soInvDetailsInfo.cusAddress;
            soInvObject.jobType = dtoObj.soInvDetailsInfo.jobType;
            soInvObject.processingUnit = dtoObj.soInvDetailsInfo.processingUnit;
            soInvObject.isSubContract = dtoObj.soInvDetailsInfo.isSubContract;
            soInvObject.delAddress = dtoObj.soInvDetailsInfo.delAddress;
            soInvObject.deliveryTerms = dtoObj.soInvDetailsInfo.deliveryTerms;
            soInvObject.endCustomerId = dtoObj.soInvDetailsInfo.endCustomerId;
            soInvObject.customerId = dtoObj.soInvDetailsInfo.customerId;
            soInvObject.country = dtoObj.soInvDetailsInfo.country;
            soInvObject.destination = dtoObj.soInvDetailsInfo.destination;
            soInvObject.payTermId = dtoObj.soInvDetailsInfo.payTermId;
            soInvObject.salePersonId = dtoObj.soInvDetailsInfo.salePersonId;
            soInvObject.shipmentTerms = dtoObj.soInvDetailsInfo.shipmentTerms;
            soInvObject.portOfEntry = dtoObj.soInvDetailsInfo.portOfEntry;
            soInvObject.unit = dtoObj.soInvDetailsInfo.unit;
            soInvObject.currency = dtoObj.soInvDetailsInfo.currency;
            soInvObject.category = dtoObj.soInvDetailsInfo.category;

            const soPoObject: SalePoDetails = new SalePoDetails();
            if(dtoObj.soPoDetailsInfo.SoPoId && operation != 'SUB JOB CREATE'){
                soPoObject.SoPoId = dtoObj.soPoDetailsInfo.SoPoId;
                soPoObject.saleOrderInfo = new SaleOrder();
                soPoObject.saleOrderInfo.saleOrderId = dtoObj.saleOrderId;
            }
            if((dtoObj.soPoDetailsInfo.SoPoId && dtoObj.soInvDetailsInfo.jobType == JobTypesEnum.SUB_JOB && operation == 'SUB JOB CREATE') || (dtoObj.soPoDetailsInfo.SoPoId && operation == 'CLONE')){
                dtoObj.soPoDetailsInfo.SoPoId = undefined;
            }
            soPoObject.additionalNote = dtoObj.soPoDetailsInfo.additionalNote;
            soPoObject.certificationId = dtoObj.soPoDetailsInfo.certificationId;
            soPoObject.rating = dtoObj.soPoDetailsInfo.rating;
            soPoObject.iscertification = dtoObj.soPoDetailsInfo.iscertification;
            soPoObject.isBrandApproved = dtoObj.soPoDetailsInfo.isBrandApproved;
            soPoObject.brandDesignType = dtoObj.soPoDetailsInfo.brandDesignType;
            soPoObject.lotCode = dtoObj.snspectionId.lotCode;
            soPoObject.loadInspection = dtoObj.snspectionId.qaQcInspection;
            const soLoadInspectionObject: SaleInspectionDetails = new SaleInspectionDetails();
            if(isUpdate==false || (isUpdate==true && dtoObj.status == SoStatusEnum.OPEN)){
                if(dtoObj.snspectionId.qaQcInspection == true){
                    soLoadInspectionObject.inspectionName = 'Load Inspection';
                    soLoadInspectionObject.isChecked = GlobalStatus.NO;
                    soInspections.push(soLoadInspectionObject);
                };
            }
            if (dtoObj.snspectionId.snspectionId) {

                if(dtoObj.snspectionId.snspectionId.length != 0){

                    if (dtoObj.snspectionId.snspectionId.length > 1) {
                        soPoObject.labInspection = dtoObj.snspectionId.snspectionId[0] + ',' + dtoObj.snspectionId.snspectionId[1];
                        if(isUpdate==false || (isUpdate==true && dtoObj.status == SoStatusEnum.OPEN)){
                            dtoObj.snspectionId.snspectionId.forEach((item:any)=>{
                                const soInspectionObject: SaleInspectionDetails = new SaleInspectionDetails();
                                soInspectionObject.inspectionName = item;
                                soInspectionObject.isChecked = GlobalStatus.NO;
                                soInspections.push(soInspectionObject);
                            })
                        }
                        

                    } else {
                        soPoObject.labInspection = dtoObj.snspectionId.snspectionId;
                        if(isUpdate==false || (isUpdate==true && dtoObj.status == SoStatusEnum.OPEN)){
                            const soInspectionObject: SaleInspectionDetails = new SaleInspectionDetails();
                            soInspectionObject.inspectionName = dtoObj.snspectionId.snspectionId;
                            soInspectionObject.isChecked = GlobalStatus.NO;
                            soInspections.push(soInspectionObject);
                        }

                    }

                }else{
                    soPoObject.labInspection = '';
                }

            }
            // if (dtoObj.snspectionId.qaQcInspection) {

            //     if (dtoObj.snspectionId.qaQcInspection.length > 0) {

            //         soPoObject.loadInspection = true;
            //     }
            // }
            
            if(isUpdate == false || (isUpdate == true && dtoObj.soInvDetailsInfo.jobType == JobTypesEnum.SUB_JOB && operation == 'SUB JOB CREATE')){

                const soTrackObj:SaleOrderTrack = new SaleOrderTrack();
                soTrackObj.DocStatus=DocStatusEnum.OPEN;
                soTrackObj.blStatus=BlStatusEnum.NOT_RECEIVED;
                soTrackObj.containerStatus=ContainerStatusEnum.NOT_READY;
                soTrackObj.fgStatus=FgStatusEnum.OPEN;
                soTrackObj.rmStatus=RmStatusEnum.OPEN;
                soTrackObj.invoiceStatus=InvoiceStatusEnum.OPEN;
                soTrackObj.createdUser='Admin';
                soTrackObj.pmStatus=PmStatusEnum.OPEN;
                soTrackObj.qualityCheckStatus=QualityCheckStatusEnum.OPEN;
                soTrackObj.saleOrderStatus=SaleOrderStatusEnum.OPEN;
                entityObj.soTrackData = soTrackObj;
            }

            // console.log(dtoObj.snspectionId)
            if (dtoObj.saleOrderId && operation != 'SUB JOB CREATE' && operation != 'CLONE')  {
                entityObj.saleOrderId = dtoObj.saleOrderId;
                entityObj.updatedUser = dtoObj.updatedUser;
            }
            entityObj.isActive = dtoObj.isActive;

            entityObj.saleOrderItemsInfo = saleOrderItmes;
            entityObj.SoInvDetailsInfo = soInvObject;
            entityObj.SoPoDetailsInfo = soPoObject;
            if(isUpdate==false || (isUpdate==true && dtoObj.status == SoStatusEnum.OPEN)){
            entityObj.SoInspectionDetailsInfo = soInspections;
            }

            return entityObj;
            // return entityObj;
        } catch (Error) {
            throw Error;
        }
    }

    public convertEntityToDto(soObj: SaleOrder): SaleOrderDto {
        const saleOrderDto = new SaleOrderDto;

        saleOrderDto.saleOrderId = soObj.saleOrderId;
        saleOrderDto.saleOrderNumber = soObj.saleOrderNumber;
        saleOrderDto.status = soObj.status;
        saleOrderDto.filePath = soObj.filePath;
        saleOrderDto.isActive = soObj.isActive;
        saleOrderDto.soProcessType = soObj.soProcessType;
        saleOrderDto.soType = soObj.soType;
        saleOrderDto.createdAt = soObj.createdAt;
        saleOrderDto.updatedAt = soObj.updatedAt;
        saleOrderDto.createdUser = soObj.createdUser;
        saleOrderDto.updatedUser = soObj.updatedUser;
        saleOrderDto.versionFlag = soObj.versionFlag;
        saleOrderDto.saleOrderItemsInfo = soObj.saleOrderItemsInfo;
        saleOrderDto.soInvDetailsInfo = soObj.SoInvDetailsInfo;
        saleOrderDto.soPoDetailsInfo = soObj.SoPoDetailsInfo;
        return saleOrderDto;
    }
    public saveExistingSOData(dtoObj: SaleOrder, soNumber):SaleOrderLog{
        const logObj = new SaleOrderLog();
        logObj.saleOrderId = dtoObj.saleOrderId
        logObj.filePath = dtoObj.filePath
        logObj.status = dtoObj.status
        logObj.soProcessType = dtoObj.soProcessType
        logObj.soType = dtoObj.soType
        //customer details
        logObj.poNumber = dtoObj.SoInvDetailsInfo.poNumber
        logObj.invoiceDate = dtoObj.SoInvDetailsInfo.invoiceDate
        logObj.edaDate = dtoObj.SoInvDetailsInfo.edaDate
        logObj.edlDate = dtoObj.SoInvDetailsInfo.edlDate
        logObj.actualEdldate = dtoObj.SoInvDetailsInfo.actualEdldate
        logObj.cusAddress = dtoObj.SoInvDetailsInfo.cusAddress
        logObj.deliveryTerms = dtoObj.SoInvDetailsInfo.deliveryTerms
        logObj.endCustomerId = dtoObj.SoInvDetailsInfo.endCustomerId
        logObj.customerId = dtoObj.SoInvDetailsInfo.customerId
        logObj.country = dtoObj.SoInvDetailsInfo.country
        logObj.destination = dtoObj.SoInvDetailsInfo.destination
        logObj.portOfEntry = dtoObj.SoInvDetailsInfo.portOfEntry
        logObj.payTermId = dtoObj.SoInvDetailsInfo.payTermId
        logObj.shipmentTerms = dtoObj.SoInvDetailsInfo.shipmentTerms
        logObj.salePersonId = dtoObj.SoInvDetailsInfo.salePersonId
        logObj.currency = dtoObj.SoInvDetailsInfo.currency
        logObj.unit = dtoObj.SoInvDetailsInfo.unit
        logObj.delAddress = dtoObj.SoInvDetailsInfo.delAddress
        logObj.buyerPoNumber = dtoObj.SoInvDetailsInfo.buyerPoNumber
        logObj.jobType = dtoObj.SoInvDetailsInfo.jobType
        logObj.isSubContract = dtoObj.SoInvDetailsInfo.isSubContract
        logObj.processingUnit = dtoObj.SoInvDetailsInfo.processingUnit
        //po-details
        logObj.rating = dtoObj.SoPoDetailsInfo.rating
        logObj.brandDesignType = dtoObj.SoPoDetailsInfo.brandDesignType
        logObj.labInspection = dtoObj.SoPoDetailsInfo.labInspection
        logObj.loadInspection = dtoObj.SoPoDetailsInfo.loadInspection
        logObj.certificationId = dtoObj.SoPoDetailsInfo.certificationId
        logObj.lotCode = dtoObj.SoPoDetailsInfo.lotCode
        logObj.isBrandApproved = dtoObj.SoPoDetailsInfo.isBrandApproved
        logObj.iscertification = dtoObj.SoPoDetailsInfo.iscertification
        logObj.additionalNote = dtoObj.SoPoDetailsInfo.additionalNote
        return logObj
    }

    public saveExistingSOitemsData(soItems:SaleOrderItemsInfo):SaleOrderItemsLog{
        console.log('soItems')
        console.log(soItems)
        const soItemObj = new SaleOrderItemsLog();
        soItemObj.saleOrderId = soItems.saleOrderId;
        soItemObj.saleOrderItemId = soItems.saleOrderItemId;
        soItemObj.itemId = soItems.itemId;
        soItemObj.minGrade = soItems.minGrade;
        soItemObj.maxGrade = soItems.maxGrade;
        soItemObj.foodTypeId = soItems.foodTypeId;
        soItemObj.valueAdditionOneId = soItems.valueAdditionOneId;
        soItemObj.valueAdditionTwoId = soItems.valueAdditionTwoId;
        soItemObj.valueAdditionThreeId = soItems.valueAdditionThreeId;
        soItemObj.valueAdditionFourId = soItems.valueAdditionFourId;
        soItemObj.valueAdditionFiveId = soItems.valueAdditionFiveId;
        soItemObj.varientId = soItems.varientId;
        soItemObj.skewerSizeItemId = soItems.skewerSizeItemId;
        soItemObj.innerBagSizeId = soItems.skewerSizeItemId;
        soItemObj.cases = soItems.cases;
        soItemObj.netAmount = soItems.netAmount;
        soItemObj.unitPrice = soItems.unitPrice;
        soItemObj.requiredCount = soItems.requiredCount;
        soItemObj.pouches = soItems.pouches;
        soItemObj.innerBags = soItems.innerBags;
        soItemObj.shrimpWeight = soItems.shrimpWeight;
        soItemObj.pouchWeight = soItems.pouchWeight;
        soItemObj.caseWeight = soItems.caseWeight;
        soItemObj.netWeight = soItems.netWeight;
        soItemObj.categoryId = soItems.categoryId;
        soItemObj.netAmount = soItems.netAmount;
        soItemObj.uomId = soItems.uomId;
        soItemObj.packStyleId = soItems.packStyleId;
        soItemObj.minGlaze = soItems.minGlaze;
        soItemObj.MaxGlaze = soItems.MaxGlaze;
        soItemObj.soakingTime = soItems.soakingTime;
        soItemObj.soakingStyle = soItems.soakingStyle;
        soItemObj.styleWeighment = soItems.styleWeighment;
        soItemObj.hlPercentage = soItems.hlPercentage;
        soItemObj.finalPercentage = soItems.finalPercentage;
        soItemObj.category = soItems.category;
        soItemObj.brandId = soItems.brandId;
        soItemObj.masterBrandId = soItems.masterBrandId;
        return soItemObj
    }
    public saveExistingBomLog(bomdataItem):BomDetailsLog{
        const bomlogObj = new BomDetailsLog()
        bomlogObj.bomId = bomdataItem.packingMaterialId
        bomlogObj.itemCategoryId = bomdataItem.itemCategoryId
        bomlogObj.itemId = bomdataItem.itemId
        bomlogObj.size = bomdataItem.size
        bomlogObj.saleOrderId = bomdataItem.saleOrderId
        bomlogObj.packingCategory = bomdataItem.packingCategory
        bomlogObj.avilableQuantity = bomdataItem.avilableQuantity
        bomlogObj.status = bomdataItem.status
        bomlogObj.requiredQuantity = bomdataItem.requiredQuantity
        bomlogObj.receivedQuantity = bomdataItem.receivedQuantity
        bomlogObj.AssignedQuantity = bomdataItem.AssignedQuantity
        bomlogObj.poQty = bomdataItem.poQty
        bomlogObj.quantity = bomdataItem.quantity
        bomlogObj.itemSubCategoryId = bomdataItem.itemSubCategoryId
        bomlogObj.isQtyRevised = bomdataItem.isQtyRevised
        bomlogObj.isActiveRevised = bomdataItem.isActiveRevised
        bomlogObj.isRequired = bomdataItem.isRequired
        return bomlogObj
    }
}